// axiosConfig.js

import axios from 'axios';

// Set common headers for all requests
axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("actk")}`;
axios.defaults.headers.common['X-Api-Key'] = process.env.REACT_APP_X_API_KEY;

export default axios;
